import moment, { Moment } from 'moment';

export const formatDateISO = (date: Moment): string => date.format('YYYY-MM-DD');

export const formatDateRangeISO = (fromDate: Moment, numberOfDays: number): string[] =>
  Array.from({ length: numberOfDays }, (_, i) =>
    moment(fromDate).add(i, 'days').format('YYYY-MM-DD')
  );
